<template>
  <div
    class="caption-button-container player-adon"
    v-if="isPosterVisible.value"
  >
    <div class="caption-scroll">
      <button
        type="button"
        class="caption-play-buttons"
        v-for="(c, i) in posterCaptions"
        :key="i"
        @click="clickCaption(c.language ? c.language : `en`, true)"
      >
        <span
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            class="play-arrow"
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M8 5v14l11-7z" /></svg></span
        >{{ c.language ? getLanguageString(c.language) : "English" }} CC
      </button>
    </div>
  </div>
</template>
<script lang="ts">
import "@/assets/video/poster-captions.css"
import { SubtitleUrls } from "@/models/captions/SubtitleUrls"
import { computed, defineComponent, PropType, Ref } from "vue"
import { getLanguageString } from "@/utils/getLanguageString"
export default defineComponent({
  props: {
    isPosterVisible: {
      type: Object as PropType<Ref<Boolean>>,
      required: true
    },
    subtitleArray: {
      type: Object as PropType<Ref<SubtitleUrls[]>>,
      required: true
    },
    clickCaption: { type: Function, required: true }
  },
  setup(props) {
    const posterCaptions = computed(() =>
      props.subtitleArray.value
        .filter(x => x.language != "en")
        .filter((x, i) => i < 5)
    )
    return { posterCaptions, getLanguageString }
  }
})
</script>
